export const AnomalyStatusEnum = {
    ALERT_ABOVE: 'ALERT_ABOVE',
    WARNING_ABOVE: 'WARNING_ABOVE',
    CLEAR: 'CLEAR',
    WARNING_BELOW: 'WARNING_BELOW',
    ALERT_BELOW: 'ALERT_BELOW'
}

export const conversionUnitFactors = {
    'LITERS_TO_GALLONS': 0.264172,
    'LITERS_TO_CUBIC_METERS': 0.001,
    'LITERS_TO_CCF' : 0.000353147,
    'CUBIC_METERS_TO_CCF': 0.353147,
    'LITERS_PER_HOURS_TO_GALLONS_PER_MINUTE': 0.00440287,
    'CELSIUS_TO_FAHRENHEIT': (celsius) => (celsius * 9/5) + 32,
    'MILLISIEMENS_TO_MICROSIEMENS': 1000,
}

export const unitMeasurementSystem = {
    'METRIC':'Metric',
    'IMPERIAL':'Imperial'
}

export const unitLabels = {
    'GALLONS': 'Gal',
    'LITERS': '\u2113',
    'CCF': 'CCF',
    'CUBIC_METERS': '\u33A5',
    'LITERS_PER_HOUR': '\u2113/h',
    'GALLONS_PER_MINUTE': 'Gal/minute',
}

export const unitSymbols = {
    'GALLONS': 'Gal',
    'LITERS': '\u2113',
    'CCF': 'CCF',
    'CUBIC_METERS': '\u33A5',
    'LITERS_PER_HOUR': '\u2113/h',
    'GALLONS_PER_MINUTE': 'gal/min',
    'CELSIUS': '°C',
    'FAHRENHEIT': '°F',
    'MICROSIEMENS': 'µS',
    'MILLISIEMENS': 'mS',
}
